import { Trans, useT } from '@eturi/react-i18next'
import { Link } from 'react-router-dom'
import { InfoModal } from '../../widgets'
import PairingComparisonTable from '../PairingOptions/PairingComparisonTable'

type TamperproofModalProps = {
	readonly onClose: () => void
}

const TamperproofModal = ({ onClose }: TamperproofModalProps) => {
	const [t] = useT('connect')

	return (
		<InfoModal hideClose={false} header={t('tamperproofing_modal.header')} onClose={onClose}>
			<p>
				<Trans i18nKey="tamperproofing_modal.description" t={t} />
			</p>

			<PairingComparisonTable />

			<InfoModal.Footer stacked>
				<Link
					className="btn btn-teal w-full mb-3 min-w-32 uppercase"
					to={{ pathname: '/connect', search: 'hideSkip=true' }}
					onClick={onClose}
				>
					{t.$('actions.full_pair')}
				</Link>

				<p className="text-center text-sm">*{t('pair_modals.pairing_options_disclaimer')}</p>
			</InfoModal.Footer>
		</InfoModal>
	)
}

export default TamperproofModal
